module.exports = __webpack_public_path__ + "img/female-bot.5b5b73f3.png";